import axios from "axios";

// ----------------------------------------------------------------
// Invoke api's using axios
// ----------------------------------------------------------------

const api = {

  // ----------------------------------------------------------------
  // Calling POST method
  // ----------------------------------------------------------------

  post : async (url, parameters, headers, responseType) => {
    try {
      const response = await axios.post(url, parameters, { headers: headers, responseType });
      return response.data;
    } catch (error) {
      return error?.response?.data || { success: false, message: "Something went wrong. Please try again." };
    }
  },

  // ----------------------------------------------------------------
  // Calling GET methods
  // ----------------------------------------------------------------

  get : async (url ,params, headers,responseType) => {
    try {
      const response = await axios.get(url, { responseType:responseType,headers: headers });

      if (response && response.data) {
        return response.data;
      } else {
        throw new Error("Response data is undefined or empty.");
      }
    } catch (error) {
      if (error.response && error.response.data) {
        return error.response.data;
      }
      throw error;
    }
  },

  // ----------------------------------------------------------------
  // Calling PUT method
  // -----------------------------------------------------------------

  put : async (url, parameters, headers) => {
    try {
      const response = await axios.put(url, parameters, { headers: headers });
      return response?.data;
    } catch (error) {
      return error?.response?.data || { success: false, message: "Something went wrong. Please try again." };
    }
  },

  // ----------------------------------------------------------------
  // Calling PATCH method
  // -----------------------------------------------------------------

  patch : async (url, parameters, headers) => {
    try {
      const response = await axios.patch(url, parameters, { headers: headers });
      return response?.data;
    } catch (error) {
      return error?.response?.data || { success: false, message: "Something went wrong. Please try again." };
    }
  },

  // ----------------------------------------------------------------
  // Calling DELETE method
  // -----------------------------------------------------------------

  delete : async (url, data, headers) => {
    try {
      const config = { headers };
      if (data !== undefined && data !== null) {
        config.data = data;
      }
      const response = await axios.delete(url, config);
      return response.data;
    } catch (error) {
      return error?.response?.data || { success: false, message: "Something went wrong. Please try again." };
    }
  }

}

// export api's invoke
export default api;
